import React from 'react';

import { Skeleton } from '@material-ui/lab';

import BaseSkeleton from '../BaseSkeleton';

import { RadioGroupSkeletonProps } from './RadioGroupSkeleton.types';

const RadioGroupSkeleton: React.FC<RadioGroupSkeletonProps> = ({
  className
}) => {
  return (
    <div className={`relative p2 flex flex-column ${className}`}>
      <BaseSkeleton width={100} height={20} className='mb2' />
      <div className="flex flex-column mt2">
        <div className='flex flex-row mb2 flex-center'>
          <Skeleton variant="circle" width={15} height={15} className="mr2" />
          <Skeleton variant="rect" width={100} height={20} className="mr2" />
        </div>
        <div className='flex flex-row flex-center'>
          <Skeleton variant="circle" width={15} height={15} className="mr2" />
          <Skeleton variant="rect" width={100} height={20} className="mr2" />
        </div>
      </div>
    </div>
  );
};

export default RadioGroupSkeleton;
export { RadioGroupSkeletonProps };
